import React from 'react';
import NotFound from '@components/not-found';
import 'styles/LoggedOutWindow.styl';

interface LoggedOutWindowProps {
  location: {state?: {message: string}};
}

export function LoggedOutWindow(props: LoggedOutWindowProps) {
  return (
    <NotFound
      title=""
      subtitle="You've been logged out."
      goBackLink={{link: '/login', title: 'Log in again'}}>
      {props.location.state?.message}
    </NotFound>
  );
}
